import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDrag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={7.833}
      cy={3.333}
      r={1.333}
      transform="rotate(90 7.833 3.333)"
    />
    <circle
      cx={12.278}
      cy={3.333}
      r={1.333}
      transform="rotate(90 12.278 3.333)"
    />
    <circle
      cx={7.833}
      cy={7.778}
      r={1.333}
      transform="rotate(90 7.833 7.778)"
    />
    <circle
      cx={12.278}
      cy={7.778}
      r={1.333}
      transform="rotate(90 12.278 7.778)"
    />
    <circle
      cx={7.833}
      cy={12.222}
      r={1.333}
      transform="rotate(90 7.833 12.222)"
    />
    <circle
      cx={7.833}
      cy={16.667}
      r={1.333}
      transform="rotate(90 7.833 16.667)"
    />
    <circle
      cx={12.278}
      cy={12.222}
      r={1.333}
      transform="rotate(90 12.278 12.222)"
    />
    <circle
      cx={12.278}
      cy={16.667}
      r={1.333}
      transform="rotate(90 12.278 16.667)"
    />
  </svg>
);
export default SvgDrag;
